import "../../../FhLabel.css";
import { useSlots, inject, computed, toValue, openBlock, createBlock, withCtx, createElementVNode, mergeProps, createVNode, renderSlot, unref, createCommentVNode, createTextVNode } from "vue";
import FhText from "../../FhText/FhText.mjs";
import FhHelpText from "../FhHelpText/FhHelpText.mjs";
import { LABEL_TAG_ENUMS } from "./constants.mjs";
import useIsFieldRequired from "../composables/useIsFieldRequired.mjs";
import { InputFieldContextKey } from "../Symbols.mjs";
import FhTooltip from "../../FhTooltip/FhTooltip.mjs";
import FhIcon from "../../FhIcon/FhIcon.mjs";
import information from "../../../icons/information.mjs";
import FhVisuallyHidden from "../../FhVisuallyHidden/FhVisuallyHidden.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = ["for"];
const _sfc_main = {
  __name: "FhLabel",
  props: {
    tag: {
      type: String,
      default: LABEL_TAG_ENUMS.LABEL,
      validator: (value) => Object.values(LABEL_TAG_ENUMS).includes(value)
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hidden: {
      default: false,
      type: Boolean
    }
  },
  setup(__props) {
    const slots = useSlots();
    const props = __props;
    const inputFieldContext = inject(InputFieldContextKey, void 0);
    const inputFieldRequired = useIsFieldRequired();
    const computedRequired = computed(
      () => toValue(inputFieldRequired) || props.required
    );
    const computedDisabled = computed(
      () => (inputFieldContext == null ? void 0 : inputFieldContext.disabled) || props.disabled
    );
    const computedLabelFor = computed(() => {
      return props.tag === LABEL_TAG_ENUMS.LABEL && (inputFieldContext == null ? void 0 : inputFieldContext.id);
    });
    const computedLabelClasses = computed(() => [
      "fh-label",
      computedDisabled.value && "fh-label--disabled"
    ]);
    const computedLabelWeight = computed(() => {
      return (inputFieldContext == null ? void 0 : inputFieldContext.inputType) === "checkbox" || (inputFieldContext == null ? void 0 : inputFieldContext.inputType) === "radio" ? "regular" : "medium";
    });
    const computedLabelColor = computed(
      () => computedDisabled.value ? "disabled" : "default"
    );
    const computedAsteriskColor = computed(
      () => computedDisabled.value ? "disabled" : "error-default"
    );
    return (_ctx, _cache) => {
      return openBlock(), createBlock(FhVisuallyHidden, {
        visible: !props.hidden
      }, {
        default: withCtx(() => [
          createElementVNode("label", mergeProps({
            class: computedLabelClasses.value,
            for: computedLabelFor.value
          }, _ctx.$attrs), [
            createVNode(FhText, {
              tag: "span",
              variant: "body-md",
              weight: computedLabelWeight.value,
              color: computedLabelColor.value,
              class: "fh-label-text"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default", {}, void 0, true),
                unref(slots).tooltip ? (openBlock(), createBlock(FhTooltip, { key: 0 }, {
                  content: withCtx(() => [
                    renderSlot(_ctx.$slots, "tooltip", {}, void 0, true)
                  ]),
                  default: withCtx(() => [
                    createVNode(FhIcon, {
                      icon: unref(information),
                      color: "subtle",
                      size: "sm",
                      "aria-hidden": void 0
                    }, null, 8, ["icon"])
                  ]),
                  _: 3
                })) : createCommentVNode("", true),
                computedRequired.value ? (openBlock(), createBlock(FhText, {
                  key: 1,
                  tag: "span",
                  variant: "body-md",
                  color: computedAsteriskColor.value,
                  "data-test-id": "fh-asterisk",
                  "aria-hidden": "true"
                }, {
                  default: withCtx(() => [
                    createTextVNode("*")
                  ]),
                  _: 1
                }, 8, ["color"])) : createCommentVNode("", true)
              ]),
              _: 3
            }, 8, ["weight", "color"]),
            unref(slots).helpText ? (openBlock(), createBlock(FhHelpText, {
              key: 0,
              disabled: computedDisabled.value
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "helpText", {}, void 0, true)
              ]),
              _: 3
            }, 8, ["disabled"])) : createCommentVNode("", true)
          ], 16, _hoisted_1)
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
};
const FhLabel = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-2d8c0d7f"]]);
export {
  FhLabel as default
};
//# sourceMappingURL=FhLabel.mjs.map
